import { TableActions } from '@core/components/Table';
import { permissaoUtils } from '@core/util/permissaoUtil';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';

const EmpresaFab = ({ cadastrarEmpresa }) => {
  const handleOpenCadastrarModal = () => {
    cadastrarEmpresa();
  };

  const actions = [
    {
      icon: <AddIcon />,
      name: 'cadastrar',
      tooltip: 'Cadastrar',
      show: permissaoUtils.minhaEmpresa().cadastrar,
      onClick: handleOpenCadastrarModal,
    },
  ];

  return <TableActions actions={actions} />;
};

export default EmpresaFab;
